export default "__VITE_ASSET__Cg0ReGju__"